import { render } from "./ErtragsrechnerView.vue?vue&type=template&id=216c0c96"
import script from "./ErtragsrechnerView.vue?vue&type=script&lang=js"
export * from "./ErtragsrechnerView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__